import { render, staticRenderFns } from "./PasswordResetStep.vue?vue&type=template&id=1880c4ec&lang=pug"
import script from "./PasswordResetStep.vue?vue&type=script&lang=js"
export * from "./PasswordResetStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports